import React, { useEffect } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import DatenschutzSection from '../components/DatenschutzSection';

const DatenschutzPage = () => {
  useEffect(() => {
    // Scrolle beim Laden der Seite nach oben
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Navbar />
      <DatenschutzSection />
      <Footer />
    </>
  );
};

export default DatenschutzPage;